import { useEffect, useState } from "react";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PublicSite from "@/components/public/PublicSite";
import "@/App.css";
import { http, setUnauthorizedHandler } from "@/lib/api";
import Header from "@/components/Header";
import Login from "@/components/Login";
import Overview from "@/components/Overview";
import Fixtures from "@/components/Fixtures";
import Standings from "@/components/Standings";
import TelegramPanel from "@/components/TelegramPanel";
import GoldPanel from "@/components/gold/GoldPanel";
import CompetitionPicker from "@/components/CompetitionPicker";

const DEFAULT_COMP = { code: "SA", name: "Serie A", type: "LEAGUE", area: "Italy" };

function Dashboard({ user, onLogout }) {
  const [tab, setTab] = useState("dashboard");
  const [comp, setComp] = useState(DEFAULT_COMP);
  return (
    <>
      <Header tab={tab} setTab={setTab} user={user} onLogout={onLogout} />
      <main className="relative z-10 max-w-7xl mx-auto px-4 sm:px-8 py-8">
        {tab === "dashboard" && <Overview goTo={setTab} />}
        {(tab === "fixtures" || tab === "standings") && <div className="mb-8"><CompetitionPicker value={comp} onChange={setComp} /></div>}
        {tab === "fixtures" && <Fixtures competition={comp} />}
        {tab === "standings" && <Standings competition={comp} />}
        {tab === "telegram" && <TelegramPanel />}
        {tab === "gold" && <GoldPanel />}
        <p className="mt-16 text-xs text-slate-500 font-mono">Pronostici generati da AI, solo a scopo informativo. Gioca responsabilmente (18+).</p>
      </main>
    </>
  );
}

function AdminApp() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    setUnauthorizedHandler(() => setUser(false));
    http.get("/auth/me").then((r) => setUser(r.data)).catch(() =>
      http.post("/auth/refresh").then((r) => setUser(r.data)).catch(() => setUser(false))
    );
  }, []);

  const logout = async () => {
    await http.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  if (user === null) return <div data-testid="auth-loading" className="relative z-10 min-h-screen grid place-items-center font-mono text-slate-400">Caricamento...</div>;
  return user ? <Dashboard user={user} onLogout={logout} /> : <Login onLogin={setUser} />;
}

function App() {
  return (
    <div className="app-root min-h-screen">
      <div className="grain" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicSite />} />
          <Route path="/admin" element={<AdminApp />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" toastOptions={{ className: "toast-dark" }} />
    </div>
  );
}

export default App;
